import React from 'react'

import { useLocation } from 'react-router-dom';


function NewFormWizard() {

  const location = useLocation()

  const formStepOne = location.pathname === '/event/create' ||
    location.pathname === '/event/feature' ||
    location.pathname === '/event/options' ||
    location.pathname === '/event/summary' ||
    location.pathname === '/event/social' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname.includes('/event/info/edit/');

  const formStepTwo = location.pathname === '/event/feature' ||
    location.pathname === '/event/options' ||
    location.pathname === '/event/summary' ||
    location.pathname === '/event/social' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' || 
    location.pathname === '/event/frame' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname.includes('/event/feature/edit/');

  const formStepThree = location.pathname === '/event/options' ||
    location.pathname === '/event/summary' ||
    location.pathname === '/event/social' ||
    location.pathname === '/event/email' ||
    location.pathname === '/event/sms' ||
    location.pathname === '/event/digital-prop' ||
    location.pathname === '/event/custom-branding' ||
    location.pathname === '/event/microsite' ||
    location.pathname === '/event/incentive-offer' ||
    location.pathname === '/event/filter' ||
    location.pathname === '/event/frame' ||
    location.pathname.includes('/event/options/edit/') ||
    location.pathname.includes('/event/sms/edit/') ||
    location.pathname.includes('/event/digital-prop/edit/') ||
    location.pathname.includes('/event/microsite/edit/') ||
    location.pathname.includes('/event/social/edit/') ||
    location.pathname.includes('/event/filter/edit/') ||
    location.pathname.includes('/event/edit/');
    location.pathname.includes('/event/edit/');

  const formStepFour = location.pathname === '/event/summary';

  return (
    <div className="form-wizard-section">
      <div id="smartwizard" className="sw-main sw-theme-arrows">
        <ul className="nav nav-tabs step-anchor">
          <li className={formStepOne ? 'active' : 'done'}>
            <span>Event Info<br /><small>Add Event Info</small></span>
          </li>
          <li className={formStepTwo ? 'active' : 'done'}>
            <span>Event Feature<br /><small>Select features for your booth</small></span>
          </li>
          <li className={formStepThree ? 'active' : 'done'}>
            <span>Event Options<br /><small>Select your photobooth options below</small></span>
          </li>
          <li className={formStepFour ? 'active' : 'done'}>
            <span>Summary<br /><small>This is a summary of your event</small></span>
          </li>
        </ul>


      </div>
    </div>
  )
}

export default NewFormWizard
